"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnterCodeForm = void 0;
Object.defineProperty(exports, "tryLogin", {
  enumerable: true,
  get: function get() {
    return _tryLogin.tryLogin;
  }
});

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _index = require("../../molecules/Loading/index.js");

var _molecules = require("../../molecules");

var _Shared = require("../Shared");

var _reactCodeInput = _interopRequireDefault(require("react-code-input"));

var _tryLogin = require("./tryLogin");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EnterCodeForm = function EnterCodeForm(_ref) {
  var width = _ref.width,
      center = _ref.center,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      generalError = _ref.generalError,
      setGeneralError = _ref.setGeneralError,
      email = _ref.email,
      setStep = _ref.setStep,
      code = _ref.code,
      setCode = _ref.setCode,
      codeError = _ref.codeError,
      setCodeError = _ref.setCodeError,
      redirectURL = _ref.redirectURL,
      forShadowUser = _ref.forShadowUser;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      busy = _useState2[0],
      setBusy = _useState2[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setGeneralError(null);

              if (!(code.length !== 6)) {
                _context.next = 4;
                break;
              }

              setGeneralError('A valid magic code is required');
              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return searchUser(email);

            case 6:
              user = _context.sent;
              console.log('onSubmit', user);

              if (!(user && user.id)) {
                _context.next = 13;
                break;
              }

              console.log('making login call');
              setBusy(true);
              (0, _Shared.loginUser)({
                userId: user.id,
                token: code,
                cb: function cb(user, error) {
                  console.log('making login call complete', user);

                  if (user) {
                    setGeneralError('');

                    if (onSuccess) {
                      onSuccess(redirectURL);
                    }
                  } else {
                    setGeneralError('Code was invalid or has expired');
                    setBusy(false);

                    if (onFailure) {
                      onFailure(redirectURL);
                    }
                  }
                }
              });
              return _context.abrupt("return");

            case 13:
              setGeneralError('Code was invalid or has expired');

              if (onFailure) {
                onFailure();
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var searchUser = function searchUser(email) {
    return new Promise(function (resolve, reject) {
      // send magic email
      var params = {};
      (0, _Shared.get)("https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/42/users/search?email=").concat(email), params, {
        contentType: 'form',
        cors: true,
        credentials: false
      }).then(function (json) {
        console.log('searchUser', json); //setStep('enter-code')

        resolve(json);
      }).catch(function (err) {
        console.log('sendMagic error', err);
        setGeneralError('Session expired please try again');
        resolve(null);
      });
    });
  };

  var styles = {};

  if (width) {
    styles.maxWidth = width;
  }

  if (center) {
    styles.margin = '0 auto';
  }

  var btnContent = "Sign in";

  if (busy) {
    btnContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_index.Loading, {
      size: "19px",
      color: "#fff"
    }), "\xA0 Signing in");
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    style: styles,
    className: "LoginForm"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    span: "12",
    center: true,
    spacingBottom: "".concat(codeError || generalError ? '0' : '8')
  }, /*#__PURE__*/_react.default.createElement(_reactCodeInput.default, {
    type: "number",
    fields: 6,
    value: code,
    pattern: "[0-9]*",
    className: "".concat(codeError || generalError ? 'error-code' : '', " "),
    onChange: function onChange(val) {
      return setCode(val);
    },
    onBlur: function onBlur(e) {
      if (code.length > 0 && code.length !== 6) {
        setCodeError('A valid magic code is required');
        return;
      }

      setCodeError('');
    },
    isValid: !generalError && !codeError
  })), // eslint-disable-next-line no-mixed-operators
  codeError || generalError && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    span: "12",
    spacingBottom: "3",
    center: true
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    small: true,
    content: generalError ? generalError : codeError,
    color: _atoms.Label.Color.Error
  })), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Submit Code Pressed",
    marginBottom: "2",
    content: btnContent,
    primary: true,
    onClick: onSubmit
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Try again Pressed",
    disabled: busy,
    content: "Try again",
    ghost: true,
    onClick: function onClick() {
      setCode('');
      setGeneralError('');
      forShadowUser ? setStep('shadow-login-magic') : setStep('login-magic');
    }
  }));
};

exports.EnterCodeForm = EnterCodeForm;